export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "isNotSignIn": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To make and receive calls you need to log in"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use your application user’s credentials."])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue"])}
        },
        "accessMicrophone": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allow access to your microphone"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To turn on the microphone, click on the microphone icon in the browser bar and reload the softphone."])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refresh"])}
        },
        "transferredCall": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The call has been transferred successfully"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["You successfully transferred the call from ", _interpolate(_named("callNumberFrom")), " to ", _interpolate(_named("callNumberTo"))])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ok"])}
        }
      },
      "ru": {
        "isNotSignIn": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Для совершения и приема звонков вам необходимо авторизоваться"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Используйте учетные данные пользователя вашего приложения."])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Продолжить"])}
        },
        "accessMicrophone": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предоставьте доступ к микрофону"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Для включения микрофона нажмите на значок микрофона в панели браузера и обновите софтфон."])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обновить"])}
        },
        "transferredCall": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Звонок успешно переведён"])},
          "description": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Вы успешно перевели звонок с номера ", _interpolate(_named("callNumberFrom")), " на номер ", _interpolate(_named("callNumberTo"))])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хорошо"])}
        }
      }
    }
  })
}
